import { render } from "./ZipFileUploader.vue?vue&type=template&id=4d7c09f6"
import script from "./ZipFileUploader.vue?vue&type=script&lang=ts"
export * from "./ZipFileUploader.vue?vue&type=script&lang=ts"
script.render = render

export default script